import Relay from 'react-relay/classic';

export default class LinkTagMutation extends Relay.Mutation {
  getVariables() {
    return {
      zapCode: this.props.zapCode,
      pin: this.props.pin
    };
  }

  getConfigs() {
    return [
      {
        type: 'REQUIRED_CHILDREN',
        children: [
          Relay.QL` fragment on LinkTagPayload {
        memberships {
          edges {
            node {
              id
            }
          }
        }
      }
      `
        ]
      }
    ];
  }

  getFatQuery() {
    return Relay.QL`
      fragment on LinkTagPayload {
        memberships {
          edges {
            node {
              id
              tag {
                code
                image
              }
              activeRank {
                rank {
                  id
                  name
                  cashBackRate
                  image
                }
                expiry
              }
              image
            }
          }
        }
      }
    `;
  }

  getMutation() {
    return Relay.QL`mutation{linkTag}`;
  }
}



// WEBPACK FOOTER //
// ./js/mutations/LinkTagMutation.js